"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var supportedLanguageList = require("./supportedLanguages.json");
var compliance_1 = require("./compliance");
exports.complianceLinks = compliance_1.default;
exports.defaultLanguageId = 'en-US';
exports.platforms = {
    APPLE: 'apple',
    GOOGLE: 'google',
    MICROSOFT: 'microsoft',
    SMARTLING: 'smartling'
};
exports.supportedLanguages = supportedLanguageList;
exports.default = { defaultLanguageId: exports.defaultLanguageId, platforms: exports.platforms, supportedLanguages: exports.supportedLanguages };
//# sourceMappingURL=localization.js.map